export default __webpack_public_path__ + "static/media/googleCloudSdk.8f2b9cce.svg";